var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#085488",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17.25c-1.468-1.187-1.562-5.094.75-6 1.227-.48 1.624 2.203 4.031 1.531.466-.13 1.563.531 1.163 1.54M4.684 3.616c.473.35.88.777 1.228 1.36.304.51.98 1.928.361 2.729-.7.905-2.728 1.21-2.728 2.045 0 .628.889 1.345 1.364 2.045.714 1.054.389 2.075 0 2.727-.202.338-.541.612-.899.828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35 8.25c.098.485.15.986.15 1.5 0 4.142-3.358 7.5-7.5 7.5-4.142 0-7.5-3.358-7.5-7.5 0-4.142 3.358-7.5 7.5-7.5.37 0 .735.027 1.091.079M12.75 6.75V9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 3.75,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlue);
export default __webpack_public_path__ + "static/media/map-blue.ea0458f174c89a66e5dbe15f1bd8cad8.svg";
export { ForwardRef as ReactComponent };